import { Actions, Subjects } from './permissionKeys'

const permissions = [
  // Users
  { action: Actions.VIEW, subject: Subjects.USERS },
  { action: Actions.EDIT, subject: Subjects.USERS },
  { action: Actions.TOGGLE_ACTIVATION, subject: Subjects.USERS },
  { action: Actions.ADJUST_BALANCE, subject: Subjects.USERS },
  { action: Actions.VIEW_PAYMENT_CARDS, subject: Subjects.USERS },
  { action: Actions.DELETE_PAYMENT_CARD, subject: Subjects.USERS },
  { action: Actions.VIEW_ONGOING_SESSIONS, subject: Subjects.USERS },
  { action: Actions.EDIT_EMAIL, subject: Subjects.USERS },
  { action: Actions.VIEW_NOTIFICATIONS, subject: Subjects.USERS },

  // Transactions
  { action: Actions.VIEW, subject: Subjects.TRANSACTIONS },
  { action: Actions.DOWNLOAD, subject: Subjects.TRANSACTIONS },
  { action: Actions.REFUND, subject: Subjects.TRANSACTIONS },
  { action: Actions.REVERSE, subject: Subjects.TRANSACTIONS },

  // Admins
  { action: Actions.VIEW, subject: Subjects.ADMINS },
  { action: Actions.EDIT, subject: Subjects.ADMINS },
  { action: Actions.INVITE, subject: Subjects.ADMINS },
  { action: Actions.DELETE, subject: Subjects.ADMINS },

  // Roles
  { action: Actions.VIEW, subject: Subjects.ROLES },
  { action: Actions.CREATE, subject: Subjects.ROLES },
  { action: Actions.EDIT, subject: Subjects.ROLES },
  { action: Actions.DELETE, subject: Subjects.ROLES },

  // Points
  { action: Actions.VIEW, subject: Subjects.POINTS },
  { action: Actions.ADD, subject: Subjects.POINTS },

  // Vouchers
  { action: Actions.VIEW, subject: Subjects.VOUCHERS },
  { action: Actions.CREATE, subject: Subjects.VOUCHERS },
  { action: Actions.EDIT, subject: Subjects.VOUCHERS },
  { action: Actions.DELETE, subject: Subjects.VOUCHERS },

  // Notifications
  { action: Actions.VIEW, subject: Subjects.NOTIFICATIONS },
  { action: Actions.CREATE, subject: Subjects.NOTIFICATIONS },
  { action: Actions.EDIT, subject: Subjects.NOTIFICATIONS },
  { action: Actions.DELETE, subject: Subjects.NOTIFICATIONS },

  // Notification Groups
  { action: Actions.VIEW, subject: Subjects.NOTIFICATION_GROUPS },
  { action: Actions.CREATE, subject: Subjects.NOTIFICATION_GROUPS },
  { action: Actions.EDIT, subject: Subjects.NOTIFICATION_GROUPS },
  { action: Actions.DELETE, subject: Subjects.NOTIFICATION_GROUPS },

  // Dashboard
  { action: Actions.VIEW, subject: Subjects.DASHBOARD },

  // Admin Actions
  { action: Actions.VIEW, subject: Subjects.ADMIN_ACTIONS },

  // Countries
  { action: Actions.VIEW, subject: Subjects.COUNTRIES },
  { action: Actions.CREATE, subject: Subjects.COUNTRIES },
  { action: Actions.EDIT, subject: Subjects.COUNTRIES },
  { action: Actions.DELETE, subject: Subjects.COUNTRIES },

  // Charging Tokens
  { action: Actions.VIEW, subject: Subjects.CHARGING_TOKENS },
  { action: Actions.CREATE, subject: Subjects.CHARGING_TOKENS },
  { action: Actions.EDIT, subject: Subjects.CHARGING_TOKENS },
  { action: Actions.DELETE, subject: Subjects.CHARGING_TOKENS },

  // Charging Tokens Design
  { action: Actions.VIEW, subject: Subjects.CHARGING_TOKENS_DESIGN },
  { action: Actions.CREATE, subject: Subjects.CHARGING_TOKENS_DESIGN },
  { action: Actions.EDIT, subject: Subjects.CHARGING_TOKENS_DESIGN },
  { action: Actions.DELETE, subject: Subjects.CHARGING_TOKENS_DESIGN },

  // OCPI Integration
  { action: Actions.VIEW, subject: Subjects.OCPI_INTEGRATION },
  { action: Actions.CREATE, subject: Subjects.OCPI_INTEGRATION },
  { action: Actions.EDIT, subject: Subjects.OCPI_INTEGRATION },
  { action: Actions.DELETE, subject: Subjects.OCPI_INTEGRATION },
  { action: Actions.INITIATE_CONNECTION, subject: Subjects.OCPI_INTEGRATION },

  // Invoices
  { action: Actions.VIEW, subject: Subjects.INVOICES },
  { action: Actions.EDIT, subject: Subjects.INVOICES },

  // Corporate Subscriptions
  { action: Actions.VIEW, subject: Subjects.CORPORATE_SUBSCRIPTIONS },
  { action: Actions.CREATE, subject: Subjects.CORPORATE_SUBSCRIPTIONS },
  { action: Actions.EDIT, subject: Subjects.CORPORATE_SUBSCRIPTIONS },
  { action: Actions.DELETE, subject: Subjects.CORPORATE_SUBSCRIPTIONS },

  // Corporates
  { action: Actions.VIEW, subject: Subjects.CORPORATES },
  { action: Actions.CREATE, subject: Subjects.CORPORATES },
  { action: Actions.EDIT, subject: Subjects.CORPORATES },
  { action: Actions.DELETE, subject: Subjects.CORPORATES },
]

export default permissions
